import Axios, { AxiosResponse } from "axios";
// import {APMCResponse} from "../../pages/license-registration-form/index"
//const base_Url = "https://gil.thesaicomputers.com/v1";

import { ApiResponse } from "../../mainMenu/allDashboard/interface"; // Adjust path as needed
import { ApiResponse2 } from "../../mainMenu/PannelEngineerDashboard/interface";
import { StreamType } from "pdf-lib/cjs/core/streams/Stream";



const base_Url = process.env.REACT_APP_BASE_URL;
// const base_Url = "http://localhost:7089";


export interface APMCResponse {
  success: boolean;
  data: any[]; // Or you can type this array if you have an interface for APMC objects
  message: string;
}



export const fetchTraderData = async (token: string, page: number, limit: number): Promise<ApiResponse> => {

  if (!token) {
   
    throw new Error("Unauthorized: No token provided");
  }

  try {
    const config = {
      headers: { Authorization: token },
    };

    const response = await Axios.get<ApiResponse>(`${base_Url}/mis-dashboard/get-trader-details/?page=${page}&limit=${limit}`, config);

    return response.data;  // Directly return the data
  } catch (error) {
   
    return error; // Ensure the caller can handle errors
  }
};



export const fetchPannelData = async (token: string, page: number, limit: number): Promise<ApiResponse2> => {

  if (!token) {
   
    throw new Error("Unauthorized: No token provided");
  }

  try {
    const config = {
      headers: { Authorization: token },
    };

    const response = await Axios.get<ApiResponse2>(`${base_Url}/mis-dashboard/get-pe-details/?page=${page}&limit=${limit}`, config);

   
    return response.data;  // Directly return the data
  } catch (error) {
   
    throw error; // Ensure the caller can handle errors
  }
};

//Counts of Trader/Panel API...
export async function fetchTraderPannelData(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-all-application-dashboard-counts`, config);
  
    return response?.data;
  } catch (err) {
    return err;
  }
}

// Trader summery and chart data API...
export async function fetchTraderTablesData(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-summary-for-apmc-and-district-trader`, config);
  
    return response?.data;
  } catch (err) {
    return err;
  }
}

// Panel summary and chart data API...
export async function fetchPanelTablesData(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-summary-for-apmc-and-district-panel`, config);
  
    return response?.data;
  } catch (err) {
    return err;
  }
}

// GCA summary and chart data API...
export async function fetchGcaTablesData(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-summary-for-apmc-and-district-gca`, config);
  
    return response?.data;
  } catch (err) {
    return err;
  }
}

//Trader Application Details API...
export async function fetchApplicantData(token: string, page: any, limit: any, searchText: any, status: any, districSelect: any, apmcSelect: any) {
  const districIds = Array.isArray(districSelect)
    ? districSelect.map((item: any) => item.value)
    : districSelect?.value && districSelect.value !== 'all'
      ? [districSelect.value]
      : [];

  const apmcIds = Array.isArray(apmcSelect)
    ? apmcSelect.map((item: any) => item.value)
    : apmcSelect?.value
      ? [apmcSelect.value]
      : [];

  const config = {
    headers: {
      Authorization: token
    },
  };

  try {
    const response = await Axios.get(`${base_Url}/common/get-application-details-trader-dashboard?statusFilter=${status}&filterdistrictId=[${districIds.join(',')}]&filterDepartmentId=[${apmcIds.join(',')}]&search=${searchText}&page=${page}&limit=${limit}`, config);
   
    return response?.data;
  } catch (err) {
    return err;
  }
}

//Panel Application Details API...
export async function fetchApplicantDataPanel(token: string, page: any, limit: any, searchText: any, status: any, districSelect: any, apmcSelect: any) {
  const districIds = Array.isArray(districSelect)
    ? districSelect.map((item: any) => item.value)
    : districSelect?.value && districSelect.value !== 'all'
      ? [districSelect.value]
      : [];

  const apmcIds = Array.isArray(apmcSelect)
    ? apmcSelect.map((item: any) => item.value)
    : apmcSelect?.value
      ? [apmcSelect.value]
      : [];
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-application-details-panel-engineer-dashboard?statusFilter=${status}&filterdistrictId=[${districIds.join(',')}]&filterDepartmentId=[${apmcIds.join(',')}]&search=${searchText}&page=${page}&limit=${limit}`, config);

    return response?.data;
  } catch (err) {
    return err;
  }
}

//Trader Application Details API...
export async function fetchApplicantDataGCA(token: string, page: any, limit: any, searchText: any, status: any, districSelect: any, apmcSelect: any) {
  const districIds = Array.isArray(districSelect)
    ? districSelect.map((item: any) => item.value)
    : districSelect?.value && districSelect.value !== 'all'
      ? [districSelect.value]
      : [];

  const apmcIds = Array.isArray(apmcSelect)
    ? apmcSelect.map((item: any) => item.value)
    : apmcSelect?.value
      ? [apmcSelect.value]
      : [];

  const config = {
    headers: {
      Authorization: token
    },
  };

  try {
    const response = await Axios.get(`${base_Url}/common/get-application-details-gca-dashboard?statusFilter=${status}&filterdistrictId=[${districIds.join(',')}]&filterDepartmentId=[${apmcIds.join(',')}]&search=${searchText}&page=${page}&limit=${limit}`, config);
    
    return response?.data;
  } catch (err) {
    return err;
  }
}

//common API for fetch District with APMC that is assigned to User...
export async function fetchUserAssignedDistrictWithAPMC(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/common/get-all-apmc-by-district-id`, config);
  
    return response?.data;
  } catch (err) {
    return err;
  }
}

export function getAllAPMC(token: string, district: string, taluka: string): Promise<APMCResponse> {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  return Axios.get<APMCResponse>(`${base_Url}/trader/get-all-apmc?district=${district}&taluka=${taluka}`, config)
    .then((response) => {

      // Now response.data is of type APMCResponse, so you can access its 'data' property
      const apmc = response.data.data;
      return response.data;
    })
    .catch((error) => {
      
      throw error;
    });
}

export function getAllDistricts(token: string): Promise<APMCResponse> {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  return Axios.get<APMCResponse>(`${base_Url}/panel/get-all-district`, config)
    .then((response) => {
    

      // Now response.data is of type APMCResponse, so you can access its 'data' property
      return response.data;
    })
    .catch((error) => {
      
      throw error;
    });
}



export async function getApplicationID(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.post(`${base_Url}/contract_farming/apply-new-agreement-application`, {}, config);
    
    return response?.data;
  } catch (err) {
    return err;
  }
}

/////////////////////////////////////////////////////
export async function newAggrement(token: string, objbody: any, applicationIdData: any) {
  
  const body = {
    couchId: objbody?.couchId,
    textField: {
      agreement_At: objbody?.formData?.at,
      agreement_on_the: objbody?.formData?.on_the,
      agreement_day_of: objbody?.formData?.day_of,
      agreement_twozerozero: objbody?.formData?.two_Hundr,
      Farmer_Name: objbody?.formData?.farmarName,
      Company_Name: objbody?.formData?.companyName,
      agreement_age: objbody?.formData?.aggrement_age,
      agreement_residingAt: objbody?.formData?.residing_at,
      AgreementFirstPartyName: objbody?.formData?.Shri_M_s,
      // AgreementFirstOfficeAt: objbody?.formData?.registered_office_at,
      AgreementFirstOfficeAt: objbody?.formData?.registered_office_at,
      villageData: objbody?.tablerows,
      FirstPartyPresenceName: objbody?.formData?.first_party,
      SecondPartyPresenceName: objbody?.formData?.second_party,
      agreement_behalf: objbody?.formData?.behalf_of_Sponsor_signed_doc?.fileName,
      doc_id: objbody?.formData?.behalf_of_Sponsor_signed_doc?.docId,

      returnForPeriodOf: objbody?.formData?.return_for_period,
      provisionsOf: objbody?.formData?.provisions_of,
      signOfContractFarmingSponsor: objbody?.formData?.sign_CF_sponsor,

      quarterForWhichReportPertains: objbody?.formData?.o_field1,
      totalQuantityPurchasedTonnes: objbody?.formData?.o_field2,
      totalValuePurchased: objbody?.formData?.o_field3,
      totalSupervisionChargesAssessed: objbody?.formData?.o_field4,
      totalSupervisionChargesPaid: objbody?.formData?.o_field5,
      totalQuantityForExportTonnes: objbody?.formData?.o_field6,
      quantityForProcessingExportTonnes: objbody?.formData?.o_field7,
      quantityOfAgrProExports: objbody?.formData?.o_field8,
      quantityProcessedExportedTonnes: objbody?.formData?.o_field9,

      nameOfCommodity: objbody?.formData?.p_field1,
      nOoFfARMERContractSigned: objbody?.formData?.p_field2,
      areainHa: objbody?.formData?.p_field3,
      quantityInTonnes: objbody?.formData?.p_field4,
      totalQuantityOfProducePurchased: objbody?.formData?.p_field5,
      valPaidtoFarmers: objbody?.formData?.p_field6,
      paymentOutNoFarmers: objbody?.formData?.p_field7,
      paymentOutstandingAmount: objbody?.formData?.p_field8

    },
    aggrement: {
      Cultivation: objbody?.aggrement?.Cultivation || objbody?.conditionsData || objbody?.formData?.conditionData19,
    }
  };
  const config = {
    headers: {
      Authorization: token
    },
  };

  try {
    const response = await Axios.post(`${base_Url}/contract_farming/submit-agreement-details?applicationId=${applicationIdData?.applicationId}`, body, config);
   
    return response?.data;
  } catch (err) {
    return err;
  }
}

//////////////////////////////////////////////////////////Fetch the count of Aggreement.
export async function getCountOfAggreement(token: string) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/contract_farming/get-dashboard-agreement-data`, config);
    return response?.data;
  } catch (err) {
    return err;
  }
}

//////////////////////////////////////////////////////////Fetch Aggreement details (table grid).
export async function getAggreementDetails(token: string, selectPending: any, totalRec: any) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/contract_farming/get-aggrement-detail/${selectPending}?page=1&limit=${totalRec}`, config);
    return response?.data;
  } catch (err) {
    return err;
  }
}

//////////////////////////////////////////////////////////
export async function getAggreementFormReview(token: string, app_id: any) {
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.get(`${base_Url}/contract_farming/get-one-aggrement-application/${app_id}`, config);
    return response?.data;
  } catch (err) {
    return err;
  }
}

////////////////////////////////////////////////////////// Forwared from MBA to MD AND approved/reject by MD.
export async function approve_reject(token: string, objbody: any) {
  // Base fields required by backend
  const body: any = {
    applicationId: objbody?.applicationId,
    status: objbody?.status,
    appStatusLevel: objbody?.appStatusLevel,
    comment: objbody?.comment,
    submittedFields: objbody?.submittedFields || {},
  };

  // Pass through extended payload if provided (to save updated agreement JSON from MBA/MBMD)
  if (objbody?.couchId || objbody?.textField || objbody?.aggrement) {
    body.couchId = objbody?.couchId;
    if (objbody?.textField) body.textField = objbody.textField;
    if (objbody?.aggrement) body.aggrement = objbody.aggrement;
    if (objbody?.deletedItemNos) body.deletedItemNos = objbody.deletedItemNos;
  }
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.post(`${base_Url}/contract_farming/approve-reject-agreement-application`, body, config);
    return response?.data;
  } catch (err) {
    return err;
  }
}

//////////////////////////////////////////////////////////////Uplaod document of stamp papar after aggeement approval.
export async function uploadDocAfterApprovalofMD(token: any, formData: any) {
  const body = formData;
  const config = {
    headers: {
      Authorization: token
    },
  };
  try {
    const response = await Axios.post(`${base_Url}/contract_farming/docs-upload-agreement?docId=`, body, config);
    return response?.data;
  } catch (err) {
    return err;
  }
}

export async function getHomeData(key: string) {

  try {
    const response = await Axios.get(`${base_Url}/superadmin/get-home-data?key=${key}`);
    return response;
  } catch (err) {
    return err;
  }
}
export async function getHomeAnnouncement(doc_Id: string, image_name: string) {

  try {
    const response = await Axios.get(`${base_Url}/superadmin/get-image/${doc_Id}/${image_name}`);
    return response;
  } catch (err) {
    return err;
  }
}
export async function getHomeImages() {

  try {
    const response = await Axios.get(`${base_Url}/superadmin/list-assets`);
    return response;
  } catch (err) {
    return err;
  }
}